// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__b6Fmo","content":"GlobalSearch_content__1YPda"};